var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingOnSite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#103B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.769 45.4712V60H25.9746V20.8984H40.9331C45.3016 20.8984 48.766 22.0353 51.3262 24.3091C53.9043 26.5828 55.1934 29.5907 55.1934 33.3325C55.1934 37.1639 53.9312 40.1449 51.4067 42.2754C48.9002 44.4059 45.3822 45.4712 40.8525 45.4712H32.769ZM32.769 40.0195H40.9331C43.3501 40.0195 45.1942 39.4556 46.4653 38.3276C47.7365 37.1818 48.3721 35.5347 48.3721 33.3862C48.3721 31.2736 47.7275 29.5907 46.4385 28.3374C45.1494 27.0662 43.377 26.4128 41.1211 26.377H32.769V40.0195Z",
    fill: "#103B5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingOnSite);
export default __webpack_public_path__ + "static/media/Parking_on_Site.44b4332a092bc5e7f8a451ea1ac8e79a.svg";
export { ForwardRef as ReactComponent };